import { Button, VStack, Text } from '@chakra-ui/react';
import React, { ReactElement } from 'react';
import { ModalAiSubCancelVariantProps, SharedModalProps } from 'types/Modal';
import { CustomModal } from '../CustomModal';
import { CustomModalContent } from '../CustomModalContent';

type Props = SharedModalProps & ModalAiSubCancelVariantProps;

export const AiSubCanceledModal = ({ handleClose, isShown, endDate }: Props): ReactElement => {
  const handleContinue = (): void => {
    handleClose();
  };

  return (
    <CustomModal isOpen={isShown} onClose={handleClose} placement="center" hideHeader size="md">
      <CustomModalContent p="30px">
        <VStack gap="30px">
          <VStack gap="15px" alignItems="flex-start">
            <Text textStyle="body.m.medium">KI-Paket nur mit aktivem Abo</Text>
            <Text textStyle="body.m.regular">
              Mit Ablauf deines NOVAHEAL-Abos ({endDate}) wird dein KI-Paket beendet – auch wenn
              noch Kontingent übrig ist.
              <br />
              Wenn du die KI-Funktion weiter nutzen möchtest, setze dein Abo fort.
            </Text>
          </VStack>
          {/* TODO: Add link to continue subscription */}
          <Button onClick={handleContinue} variant="primary" w="full">
            Verstanden
          </Button>
        </VStack>
      </CustomModalContent>
    </CustomModal>
  );
};
